import *as React from 'react';

import {Link, useHistory} from 'react-router-dom';

import '@app/scss/components/notFound.scss';

const NotFound = ({header = 'Woof! Looks like this page doesn’t exist.', replacePath = true}) => {
	const history = useHistory();
	
	React.useEffect(() => {
		replacePath ? history.replace('/not-found') : null;
	}, []);
	
	return (
		<div className="not-found">
			<div className="not-found__wrapper">
				<div className="not-found-inner">
					<h2>{header}</h2>
					<h6>Try searching our site or head back to our home page.</h6>
					<img src={require('@app/content/notFound.jpg')} alt="cat-and-dog"/>
					<button className="btn btn-md btn-primary" onClick={() => history.goBack()}>Back to previous page</button>
				</div>
			</div>
			
		</div>
	);
};

export default NotFound;